import { Collapse } from 'antd';
import type { CollapseProps } from 'antd';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { ReactNode } from 'react';

export const OwnTractorFAQ = () => {
  const panelStyle: React.CSSProperties = {
    border: 'none',
    paddingTop: 24,
  };

  const items: CollapseProps['items'] = [
    {
      key: 'for-non-business-person',
      label: <Question>{'사업자가 아닌 농민도 등록할 수 있나요?'}</Question>,
      children: <Answer>{'네, 일반 농민도 등록할 수 있으며, 등록 개수 제한 없이 자유롭게 등록 가능합니다.'}</Answer>,
      style: panelStyle,
    },
    {
      key: 'difference-between-sell-tractor',
      label: <Question>{'판매 트랙터와 무엇이 다른가요?'}</Question>,
      children: (
        <Answer>
          {
            '판매 트랙터는 가격이 공개되지만, 보유 트랙터는 가격이 노출되지 않습니다. 대신, 입력한 트랙터 정보를 통해 인기와 가격 제안을 받을 수 있습니다.'
          }
        </Answer>
      ),
      style: panelStyle,
    },
    {
      key: 'free-registration',
      label: <Question>{'등록 무료인가요?'}</Question>,
      children: (
        <Answer>
          {'네! 등록부터 홍보까지 100% 무료입니다. 플루바 마켓 회원이라면 비용 없이 보유 트랙터를 등록할 수 있습니다.'}
        </Answer>
      ),
      style: panelStyle,
    },
  ];

  return (
    <Container id={'own-tractor-entry-faq'}>
      <Title>{'자주 묻는 질문'}</Title>
      <Collapse
        items={items}
        bordered={false}
        expandIconPosition={'start'}
        size={'small'}
        expandIcon={({ isActive }) =>
          (
            <AngleIconWrapper>
              <Icon name={isActive ? 'AngleUp' : 'AngleDown'} size={'Medium'} fill={'#898B94'} />
            </AngleIconWrapper>
          ) as ReactNode
        }
        style={{ width: '100%', backgroundColor: '#f2f2f7' }}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 32px 16px;

  background-color: #f2f2f7;
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const Question = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 24px */
`;

const Answer = styled.p`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 24px */

  padding-top: 8px;
  padding-left: 24px;
`;

const AngleIconWrapper = styled.div`
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
